import React, { useState } from 'react';
import { ReleaseBrowseCommon } from './../browse/ReleaseBrowseCommon';
import { Header, Divider, Icon, Message } from 'semantic-ui-react'

export function RecordingTakeReleases(props) {
	const [childRendering, setChildRendering] = useState(true);
	return (
		<>
			{childRendering &&
				<>
					<Divider horizontal inverted>
						<Header as='h4' inverted>
							<Icon name='radio' />
							Releases
						</Header>
					</Divider>
					<Message warning style={{textAlign:'center'}}>
						<Message.Header>Release-Recording matches are in beta, which means the discographical accuracy is still being verified and cross-referenced.<br/><br/>For recordings with alternate takes or multiple versions in circulation, it will not be accurate until human-reviewed.</Message.Header>
					</Message>
					<ReleaseBrowseCommon
						take={props.take} variants={props.variants} variant={props.variant}
						event={props.event} event_variants={props.event_variants} 
						film={props.film} film_variants={props.film_variants} 
						radio={props.radio} radio_variants={props.radio_variants} 
						television={props.television} television_variants={props.television_variants} 
						advert={props.advert} advert_variants={props.advert_variants} 
						urlParams={false} relatedRendered={(val) => setChildRendering(val)} slim={true}/>
				</>
			}
		</>
	);
}